'use client';

import { use } from 'react';
import { useRouter } from 'next/navigation';
import { ChatWidget } from '@/components/chat/ChatWidget';

interface ChatSessionPageProps {
  params: Promise<{
    session: string;
  }>;
}

export default function ChatSessionPage({ params }: ChatSessionPageProps) {
  const { session } = use(params);
  const router = useRouter();

  const handleBookingRequest = () => {
    router.push(`/booking?session=${session}`);
  };

  return (
    <div className="flex h-screen flex-col">
      <header className="border-b bg-white px-6 py-4">
        <div className="mx-auto flex max-w-7xl items-center justify-between">
          <h1 className="text-xl font-bold text-indigo-600">didatticloud</h1>
        </div>
      </header>

      <main className="flex-1">
        <ChatWidget
          sessionId={session}
          onBookingRequest={handleBookingRequest}
          embedded
        />
      </main>
    </div>
  );
}
